import React, { Component } from 'react'
import PropTypes from 'prop-types'

class StixInfos extends Component {
  constructor (props) {
    super(props)

    this.state = {
      equivalence: this.props.equivalence || 0
    }
  }
  render () {
    return (

      <div className='row'>
        <div className='col-12 px-2 py-2'>
          <p className='txt-body'>
               Veja o que você precisa saber:
          </p>
        </div>
        <div className='col-12 px-2'>
          <div className='row'>
            <div className={`col-12 col-md-6 py-1 ${this.props.equivalence === 0 ? 'd-none' : 'd-block'}`}>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_star color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>
                    {
                      this.props.equivalence === 0 ? (
                        <div className='btn-loading mr-auto ml-auto'>
                          <div />
                          <div />
                          <div />
                          <div />
                        </div>
                      ) : (
                        <div>
                          <span className='color-featured'>
                            {this.props.equivalence > 0 ? this.props.equivalence : '** '} pontos
                          </span>
                          <span>  </span>
                          equivalem a
                          <span>  </span>
                          <span className='color-featured'>1 estrela</span> dos programas Pão de Açúcar Mais e Clube Extra *
                        </div>
                      )
                    }
                  </p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_dot_down color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>As estrelas serão <span className='color-featured'>creditadas automaticamente</span> no mesmo CPF de sua conta iupp</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_cart color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>Você poderá trocar suas <span className='color-featured'>estrelas por prêmios</span> diretamente nos apps Pão de Açúcar Mais e do Clube Extra</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_touch color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'><span className='color-featured'>Após escolher os prêmios no app</span>, você poderá retirá-los nas lojas físicas do Pão de Açúcar ou do Extra ou nos respectivos parceiros do catálogo</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_promo color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'><span className='color-featured'>“Vales Compra”</span> do Pão de Açúcar e Extra também poderão ser usados em pedidos feitos pelo <span className='color-featured'>e-commerce</span></p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_info color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>Para mais informações <a href='#' className='color-featured txt-body-sm'>clique aqui</a>.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

StixInfos.propTypes = {
  equivalence: PropTypes.number
}

export default StixInfos



// WEBPACK FOOTER //
// ./src/features/Stix/StixInfos.js